import { fetchProgramAreas } from './blue-rhino';
const { redirect_toast_text } = window.BlueRhinoConfig;

const delivery = {
  show(el) {
    if (el && el.classList.contains('hidden')) el.classList.remove('hidden');
  },

  hide(el) {
    if (el && !el.classList.contains('hidden')) el.classList.add('hidden');
  },

  toggle(el, className, force) {
    if (!el) return;
    if (typeof force === 'boolean') {
      el.classList.toggle(className, force);
    } else {
      el.classList.toggle(className);
    }
  },

  updateZipInURL(zip) {
    const url = new URL(window.location.href);
    url.searchParams.set('z', zip);
    window.history.replaceState({}, '', url);
  },

  setText(el, text) {
    if (el) el.textContent = text;
  },

  clearInput(input) {
    if (input) input.value = '';
  },

  formatDeliveryText(zip) {
    return `${zip || ''}`;
  },

  validateEmail(email) {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(String(email).toLowerCase());
  },

  handleZipInputChange(zipInput, manualCTA) {
    const value = zipInput?.value.trim();
    if (manualCTA) {
      manualCTA.disabled = !value;
    }
  },

  async handleLocateManualGeneric(value) {
    if (!value) throw new Error('Enter a city or zip code.');

    const response = await fetchProgramAreas(value);
    if (response.length == 0) return { zip: value, deliverable: 'not-at-all' };
    const res = this.isChicagoServiceable(response);
    return res;
  },

  isChicagoServiceable(response) {
    if (!Array.isArray(response) || response.length === 0) {
      return { zip: null, deliverable: 'not-at-all', action: 'propane-finder' };
    }

    // Rule 1: Check for programID 5 with status A
    const program5Active = response.find(
      (p) => p.programID == 5 && p.status === 'A',
    );
    if (program5Active) {
      return {
        zip: program5Active.zipCode,
        deliverable: true,
        action: 'buy-box',
      };
    }

    // Rule 2: Check for any non-5 program with status I
    const non5Inactive = response.find(
      (p) => p.programID != 5 && p.status === 'I',
    );
    if (non5Inactive) {
      return {
        zip: non5Inactive.zipCode,
        deliverable: 'not-at-all',
        action: 'propane-finder',
      };
    }

    // Rule 3: If all are non-5 programs with status A
    const allNon5Active = response.every(
      (p) => p.programID != 5 && p.status === 'A',
    );
    if (allNon5Active) {
      return {
        zip: response[0].zipCode,
        deliverable: false,
        action: 'delivery-address',
      };
    }

    // Rule 4: Fallback
    return {
      zip: response[0].zipCode,
      deliverable: 'not-at-all',
      action: 'propane-finder',
    };
  },

  redirectToNearestStoreFinder(zip) {
    this.showToast(`${redirect_toast_text}`);
    const url = `https://bluerhino.com/propane-finder?z=${encodeURIComponent(
      zip,
    )}`;
    setTimeout(() => {
      window.location.href = url;
    }, 2000);
  },

  redirectToLegacyBuyBox(zip) {
    const url = `https://bluerhino.com/home-delivery/checkout/delivery-address`;
    setTimeout(() => {
      window.location.href = url;
    }, 2000);
  },

  async handleLocateAutoGeneric() {
    if (!navigator.geolocation) {
      throw new Error('Geolocation is not supported.');
    }

    try {
      const { coords } = await new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(resolve, reject);
      });

      let postalCode;
      try {
        postalCode = await delivery.resolveCoords(
          coords.latitude,
          coords.longitude,
        );
      } catch {
        postalCode = await this.getZipFromIP();
      }

      const response = await fetchProgramAreas(postalCode);
      if (response.length === 0)
        return { zip: postalCode, deliverable: 'not-at-all' };

      const res = this.isChicagoServiceable(response);
      return res;
    } catch (err) {
      console.error('Geolocation error:', err);
      throw err;
    }
  },

  async resolveCoords(lat, lng) {
    try {
      const url = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}&zoom=18&addressdetails=1`;

      const response = await fetch(url);

      if (!response.ok) {
        throw new Error('Failed to fetch reverse geocoding data');
      }

      const data = await response.json();
      const postalCode = data?.address?.postcode || 'Postal code not found';

      return postalCode;
    } catch (error) {
      console.error('Geocoding error:', error);
      throw error;
    }
  },

  async getZipFromIP() {
    try {
      const res = await fetch('https://ipapi.co/json/');
      if (!res.ok) throw new Error('IP API failed');
      const data = await res.json();
      return data.postal || null;
    } catch (err) {
      console.error('IP-based lookup failed:', err);
      return null;
    }
  },

  showToast(message) {
    const toast = document.createElement('div');
    toast.textContent = message;

    toast.className = `
      fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2
      bg-blue-900 text-gray-10 text-lg rounded-md px-5 py-3 flex justify-center w-[80%] lg:w-fit
      shadow-lg z-[9999] transition-opacity duration-500
    `;

    document.body.appendChild(toast);

    setTimeout(() => {
      toast.classList.add('opacity-0');
      setTimeout(() => toast.remove(), 500);
    }, 6000);
  },
};

export { delivery };
